<template>
  
        <div class="zigzag"></div>
     
</template>

<script>
export default {
  name: "ZigZag",

  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
$height: 32px;
$halfheight: ($height/2);
$thickness: 120%; // increase to make the line thicker
$offset: 4px;
$backgroundcolor: white;
// $linecolor: rgb(13, 163, 106);
$linecolor: rgb(100, 109, 194);

.zigzag {
  margin: 0 0;
  background: $backgroundcolor;
  position: relative;
  height: 3px;
  z-index: 1;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
  }
  &:before {
    height: ($height - $offset);
    top: $thickness;
    background: linear-gradient(-135deg, $linecolor $halfheight, transparent 0)
        0 $halfheight,
      linear-gradient(135deg, $linecolor $halfheight, transparent 0) 0
        $halfheight;
    background-position: top left;
    background-repeat: repeat-x;
    background-size: $height $height;
  }
  &:after {
    height: $height;
    top: 100%;
    background: linear-gradient(
          -135deg,
          $backgroundcolor $halfheight,
          transparent 0
        )
        0 $halfheight,
      linear-gradient(135deg, $backgroundcolor $halfheight, transparent 0) 0
        $halfheight;
    background-position: top left;
    background-repeat: repeat-x;
    background-size: $height $height;
  }
}
</style>
